:host {
  display: flex;
  align-items: center;
  .icon {
    display: flex;
  }
  #language-select {
    border: none;
    background-color: var(--color-background);
    &:focus-visible {
      outline: none;
    }
  }
}
